import React, { useEffect, useState } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  Box,
  Button,
  Container,
  Drawer,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import CustomButton from "./SquareButton";
import { useAssessment } from "../../providers/AssessmentProvider";
import { getAssessmentPageStyle } from "../../components/customstyles/AssessmentPageStyle";
import { useAssessmentWalkthrough } from "../../providers/AssessmentWalkthroughProvider";
import { recordCustomEvent } from "../../pinpointConfig";
import AssessmentWalkThroughDrawerHandler from "./AssessmentWalkThroughDrawerHandler";
import { Helmet } from "react-helmet";

const useStyles = () => {
  let theme = useTheme();
  return getAssessmentPageStyle(theme);
};

const NotesContent = ({ section, item, index, handleNotesDrawer }) => {
  const { handleNotes } = useAssessment();
  const [notes, setNotes] = useState("");
  return (
    <>
      <Helmet>
        <title>New Assessment</title>
      </Helmet>
      <Box
        sx={{
          padding: "20px",
          backgroundColor: "white",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontSize: "20px", fontWeight: "bold" }}>
          {item.name}
        </Typography>
        <Button
          variant="text"
          onClick={() => {
            handleNotes(section, index, notes);
            handleNotesDrawer(null);
          }}
          sx={{
            color: "#0D47A1",
            fontSize: "14px",
            fontWeight: "bold",
          }}
        >
          Done
        </Button>
      </Box>
      <Box sx={{ marginX: "10px", mt: "10px" }}>
        <TextField
          sx={{
            "& .MuiOutlinedInput-root": {
              "&.Mui-focused fieldset": {
                borderColor: "#1E88E5", // Change border color when focused
              },
            },
            "& .MuiOutlinedInput-input": {
              padding: 0, // Set padding to 0
            },
            width: "100%",
            border: 0,
            borderLeft: "1px solid #0000001F",
            padding: "0px 10px",
          }}
          InputProps={{ disableUnderline: true }}
          maxRows={10}
          placeholder="Start typing notes here"
          multiline
          defaultValue={item.notes}
          fullWidth
          id="outlined-basic"
          variant="standard"
          value={notes}
          onChange={(event) => {
            let note = event.target.value;
            setNotes(note);
            // handleNotes(section, index, note);
          }}
        />
      </Box>
    </>
  );
};

function AssessmentPage({ section }) {
  const [showNotesDrawer, setShowNotesDrawer] = useState(false);
  const [showWalkhThroughDrawer, setShowWalkhThroughDrawer] = useState(false);
  const styles = useStyles();
  const isMobile = useMediaQuery("(max-width: 900px)");
  const { assessment, handleAssessmentToggle, drawerWidth } = useAssessment();
  const { showOrHideBottomBar } = useAssessmentWalkthrough();
  const handleNotesDrawer = (key) => {
    setShowNotesDrawer(key);
  };
  const handleWalkThroughDrawer = (key) => {
    setShowWalkhThroughDrawer(key);
    if (isMobile) {
      showOrHideBottomBar(key !== null ? true : false);
    }
  };
  const updatePinpointEvent = (key) => {
    recordCustomEvent(window.location.pathname + `/${key}`);
  };

  useEffect(() => {
    const handleCustomPinPointCall = async () => {
      updatePinpointEvent(section);
    };
    handleCustomPinPointCall();

    setShowNotesDrawer(null);
    setShowWalkhThroughDrawer(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [section]);
  let questionCount;
  const handleQuestionCount = () => {
    if (section === "bodyAreas") {
      questionCount = 0;
    } else if (section === "globalJudgements") {
      questionCount = 7;
    } else if (section === "dentalStatus") {
      questionCount = 10;
    }
  };
  handleQuestionCount();

  return (
    <div
      style={{ display: "flex", justifyContent: "center" }}
      className="FSUnmask"
    >
      {/* Question Section */}
      <div
        style={{
          marginTop: isMobile ? "90px" : "0px",
          width: "760px",
          paddingTop: isMobile ? "20px" : "100px",
          paddingBottom: isMobile ? "20px" : "100px",
        }}
      >
        {assessment[section]["sectionAssessment"].map(
          (item, subSectionindex) => {
            // addInitialDrawerState(item.key);
            return (
              <div
                key={`section_${subSectionindex}`}
                style={{
                  ...styles.subSectionContainer,
                  borderBottom:
                    subSectionindex < assessment[section].length - 1
                      ? "2px solid #0304041A"
                      : "0px",
                }}
              >
                <div style={{ ...styles.subSectionHeadingContainer }}>
                  <div style={{ ...styles.subSectionHeadingTextContainer }}>
                    <h2
                      style={{
                        ...styles.subSectionHeadingTextContainer.h2,
                      }}
                    >
                      {item.name}
                    </h2>
                    <div
                      style={{ ...styles.subSectionInfoContainer }}
                      onClick={() => {
                        updatePinpointEvent(
                          `${section === item.key ? "" : section + "/"}${
                            item.key
                          }/whatsthis`
                        );
                        handleWalkThroughDrawer(item.key);
                      }}
                    >
                      <h3
                        style={{
                          fontSize: "15px",
                          fontWeight: "400",
                          margin: 0,
                        }}
                      >
                        What's This?
                      </h3>
                      <InfoOutlinedIcon fontSize="15px" />
                    </div>
                  </div>
                  <Button
                    variant="outlined"
                    endIcon={<EditNoteOutlinedIcon />}
                    style={{ ...styles.addNote }}
                    onClick={() => {
                      updatePinpointEvent(
                        `${section === item.key ? "" : section + "/"}${
                          item.key
                        }/notes`
                      );
                      handleNotesDrawer(item.key);
                    }}
                  >
                    Add Note
                  </Button>
                </div>
                <div style={{ ...styles.questionsContainer }}>
                  {item.questions.map((question, questionIndex) => {
                    return (
                      <>
                        <div
                          style={{
                            padding: "20px",
                          }}
                        >
                          <div style={{ ...styles.questionsTextContainer }}>
                            <div
                              style={{
                                ...styles.questionsText,
                              }}
                            >
                              <p style={{ margin: 0 }}>{++questionCount}.</p>
                              <p style={{ margin: 0 }}>{question.title}</p>
                            </div>
                            {question.required ? (
                              <p style={{ margin: 0 }}>Required</p>
                            ) : (
                              <></>
                            )}
                          </div>
                          <p style={{ ...styles.questionsDescription }}>
                            {question.description}
                          </p>
                          <p
                            key={`optionstext${questionIndex}`}
                            style={{
                              color: "#09306D",
                              textAlign: "center",
                              margin: "5px 0px",
                            }}
                          >
                            {item.options.text}
                          </p>
                          <Container style={{ ...styles.optionsContainer }}>
                            {item.options.buttons.map((button) => (
                              <CustomButton
                                key={button.value}
                                value={button.severity}
                                label={button.name}
                                section={section}
                                subSectionindex={subSectionindex}
                                questionIndex={questionIndex}
                                isSelected={
                                  question.selectedValue === button.severity
                                }
                                onClick={handleAssessmentToggle}
                              />
                            ))}
                          </Container>
                        </div>
                        {questionIndex < item.questions.length - 1 ? (
                          <hr style={{ ...styles.horizonalLine }} />
                        ) : (
                          <></>
                        )}
                      </>
                    );
                  })}
                </div>
              </div>
            );
          }
        )}
      </div>
      {/* Notes Drawer */}
      {assessment[section]["sectionAssessment"].map((item, index) => {
        return (
          <React.Fragment key={item.key}>
            {isMobile ? (
              <Drawer
                anchor="bottom" // Makes the drawer open from the bottom
                open={showNotesDrawer === item.key} // Controls whether the drawer is open or closed
                onClose={() => handleNotesDrawer(null)}
                // Closes the drawer when clicking outside
              >
                {/* Drawer content */}
                <Box
                  role="presentation"
                  sx={{
                    // padding: 2,
                    textAlign: "center",
                    backgroundColor: "#f1f1f1",
                    minHeight: "50vh",
                    borderTopRightRadius: "10px",
                    borderTopLeftRadius: "10px",
                  }}
                >
                  <NotesContent
                    section={section}
                    item={item}
                    index={index}
                    handleNotesDrawer={handleNotesDrawer}
                  />
                </Box>
              </Drawer>
            ) : (
              <div
                style={{
                  display: showNotesDrawer === item.key ? "flex" : "none",
                  backgroundColor: "white",
                  position: "fixed",
                  right: 0,
                  width: drawerWidth,
                  marginTop: "100px",
                  height: "100%",
                  zIndex: 1,
                  border: "1px solid #E0E0E0",
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "white",
                    width: "330px",
                  }}
                >
                  <NotesContent
                    section={section}
                    item={item}
                    index={index}
                    handleNotesDrawer={handleNotesDrawer}
                  />
                </Box>
              </div>
            )}
          </React.Fragment>
        );
      })}
      {/* Walkthrough Drawer */}
      {assessment[section]["sectionAssessment"].map((item, index) => {
        return (
          <AssessmentWalkThroughDrawerHandler
            item={item}
            index={index}
            isMobile={isMobile}
            handleWalkThroughDrawer={handleWalkThroughDrawer}
            showWalkhThroughDrawer={showWalkhThroughDrawer}
          />
        );
      })}
    </div>
  );
}

export default AssessmentPage;
